<template>
  <div class="wrapper">
    <v-layout row wrap class="mapContainer">
      <v-flex xs2>
        <v-list dense subheader border class="groupList">
          <v-subheader>地点グループ名</v-subheader>
          <p class="caption grey--text pl-3">
            あと{{ remainingGroupCount }}個追加できます
          </p>
          <PointGroup
            v-for="pointGroup in selectedPointGroupList"
            :point-group="pointGroup"
            :key="pointGroup.id"
          />
        </v-list>
      </v-flex>
      <v-flex align-self-center xs10>
        <div class="mapWrapper">
          <div class="map">
            <MglMap
              :access-token="accessToken"
              :map-style="mapStyle"
              :center.sync="center"
              :zoom="6"
              @load="onMapLoaded"
            >
              <MglMarker
                ref="marker"
                v-for="location in selectedPointGroupLocationList"
                :coordinates="location.shape.getCoordinates()"
                :key="location.id"
              >
                <template slot="marker">
                  <div :class="styles.colorAndOpacity(location, false)" />
                </template>
              </MglMarker>
            </MglMap>
          </div>
        </div>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import { MglMap, MglMarker } from 'vue-mapbox'
import MapboxLanguage from '@mapbox/mapbox-gl-language'
import { minBy, maxBy } from 'lodash/math'
import { mapActions, mapGetters } from 'vuex'
import markerUIStyles from '@/components/Shared/Simulation/util/markerStyle'
import PointGroup from './SimulationContentDeliveryLocationGroupImportGroup'

export default {
  name: 'SimulationContentDeliveryLocationGroupImportMap',
  components: { MglMap, MglMarker, PointGroup },
  props: {
    remainingGroupCount: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      accessToken:
        'pk.eyJ1Ijoid25vZ3VjaGkiLCJhIjoiY2lqY2c2dmxuMDAxZHUxamJwMGl3ZnV5ciJ9.WBilN5epB7RdyO-JbUQd2A',
      mapStyle: 'mapbox://styles/wnoguchi/ckbu3bvc303t41ip4yzmywi29',
    }
  },
  computed: {
    ...mapGetters('simulation', [
      'selectedPointGroupList',
      'selectedPointGroupLocationList',
      'importMapIsFitBounce',
      'pointGroupImportMapCenter',
    ]),
    styles() {
      return markerUIStyles
    },
    center: {
      get() {
        const { longitude, latitude } = this.pointGroupImportMapCenter
        return [longitude, latitude]
      },
      set(center) {
        this.setMapCenter(center)
      },
    },
  },
  watch: {
    selectedPointGroupLocationList(locationList) {
      if (locationList.length === 0) {
        return false
      }
      this.$nextTick(() => {
        const lngLats = locationList.map(location => {
          const [lng, lat] = location.shape.getCoordinates()
          return {
            lng,
            lat,
          }
        })
        const maxLng = maxBy(lngLats, lngLat => lngLat.lng)
        const minLng = minBy(lngLats, lngLat => lngLat.lng)
        const maxLat = maxBy(lngLats, lngLat => lngLat.lat)
        const minLat = minBy(lngLats, lngLat => lngLat.lat)

        const padding = 50

        // 南西と東北の座標を指定して全ての地点が入る矩形を指定する
        this.map.fitBounds(
          [
            [minLng.lng, minLat.lat],
            [maxLng.lng, maxLat.lat],
          ],
          { padding },
        )
      })
    },
  },
  methods: {
    ...mapActions('simulation', {
      setMapCenter: 'SET_POINT_GROUP_IMPORT_MAP_CENTER',
    }),
    async onMapLoaded(event) {
      this.map = event.map

      const language = new MapboxLanguage()

      this.map.setStyle(language.setLanguage(this.map.getStyle(), 'ja'))
      this.map.resize()
      this.$emit('loaded')
    },
  },
}
</script>

<style scoped>
.wrapper {
  border: 1px solid gray;
}
.mapContainer {
  height: 300px;
}
.groupList {
  height: 300px;
  overflow: scroll;
}
.mapWrapper {
  position: relative;
  min-height: 300px;
}
.map {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  overflow: hidden;
}
</style>
